import { defaultFilterBarConfig } from './filterBars';

import type { LayoutPageConfig } from './types';

export const testPageConfig = {
  namespacesRequired: [],
  layout: {
    filterBar: defaultFilterBarConfig,
    noPaddedContent: false,
  },
} satisfies LayoutPageConfig;
